'use client'

import { type ReactNode, useEffect, useState } from 'react'
import { datadogRum } from '@datadog/browser-rum'
import { Dialog } from 'ui/src/components/Dialog/Dialog'
import { visuallyHidden } from 'ui/src/utils/visibility.css'
import { dialogWindow } from './DebugDialog.css'

const CTRL_SHIFT_D = '∆'

export const DebugDialog = (props: { children: ReactNode }) => {
  const [isOpen, setOpen] = useState(false)

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey && event.key === 'd') || event.key === CTRL_SHIFT_D) {
        datadogRum.addAction('open debug-dialog')
        setOpen(true)
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [])

  return (
    <Dialog.Root open={isOpen} onOpenChange={setOpen}>
      <Dialog.Content onClose={() => setOpen(false)}>
        <Dialog.Title className={visuallyHidden}>Debug tools</Dialog.Title>
        <Dialog.Window className={dialogWindow}>{props.children}</Dialog.Window>
      </Dialog.Content>
    </Dialog.Root>
  )
}
